import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MyImgRound from "../components/MyImgRound.js";
import Settings from "./Mydata/Settings/Settings.js";
import Timer from "../components/Timer.js";
import { word } from '../word.js'
import Cookies from 'js-cookie'

const ManagerMenu = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Redux state
    const employee = useSelector((state) => state.manager.employee);
    const notification = useSelector((state) => state.manager.notification);

    const [showSettingsModal, setShowSettingsModal] = useState(false);

    const menuManager = [
        { id: 1, url: "/main_employee/staff", title: word.stuff },
        { id: 2, url: "/main_employee/organization", title: word.organizations },
        { id: 3, url: "/main_employee/users", title: word.users },
        { id: 4, url: "/main_employee/tasks", title: word.tasks },
        { id: 13, url: "/main_employee/agent-task", title: word.agentTasks },
        { id: 14, url: "/main_employee/admin-agent", title: "Առաջադրանքների վճարում" },
        { id: 15, url: "/main_employee/wallet", title: "Դրամապանակ" },

        { id: 5, url: "/main_employee/archive", title: word.archive },
        { id: 6, url: "/main_employee/repeated_task", title: word.periodically_repetitive_tasks },
        { id: 7, url: "/main_employee/notification", title: word.notification },
        { id: 8, url: "/main_employee/reports", title: word.reports },
        { id: 9, url: "/main_employee/organization_file", title: word.accountant_file },
        { id: 10, url: "/main_employee/day_off", title: word.dayOff },
        { id: 11, url: "/main_employee/surveys", title: 'Հարցումներ' },
        { id: 12, url: "/main_employee/calendar?type=0", title: 'Օրացույց' },

    ];

    const menuAccountant = [
        { id: 1, url: "/main_employee/tasks", title: word.tasks },
        { id: 13, url: "/main_employee/agent-task", title: word.agentTasks },
        { id: 2, url: "/main_employee/repeated_task", title: word.periodically_repetitive_tasks },
        { id: 3, url: "/main_employee/archive", title: word.archive },
        { id: 4, url: "/main_employee/note", title: word.note },
        { id: 5, url: "/main_employee/notification", title: word.notification },
        { id: 6, url: "/main_employee/organization_file", title: word.accountant_file },
        { id: 7, url: "/main_employee/day_off", title: word.dayOff },
        { id: 11, url: "/main_employee/surveys", title: 'Հարցումներ' },
        { id: 12, url: "/main_employee/calendar?type=0", title: 'Օրացույց' },
    ];
    const menuAgent = [
        { id: 13, url: "/main_employee/agent-task", title: word.agentTasks },
        { id: 2, url: "/main_employee/wallet", title: "Դրամապանակ" },
        { id: 12, url: "/main_employee/calendar?type=0", title: 'Օրացույց' },

    ];
    const profession = Cookies.get('profession') || localStorage.getItem('profession')
    const menuList = profession === "manager" ? menuManager : profession === "agent" ? menuAgent : menuAccountant;
    
    // Filter out organizations (id: 2), users (id: 3), and organization_file for PEK theme
    const filteredMenuList = process.env.REACT_APP_SERVER === 'PEK' 
        ? menuList.filter(item => {
            // For manager: filter id 2, 3, and organization_file (id 9)
            // For accountant: filter organization_file (id 6)
            if (profession === "manager") {
                return item.id !== 2 && item.id !== 3 && !item.url.includes('/organization_file');
            } else if (profession === "accountant") {
                return !item.url.includes('/organization_file');
            }
            return true; // For agent, don't filter anything
        })
        : menuList;
    
    const login = useSelector((state) => state.manager.employee);
    const isAdmin = login?.user_id === 86 || login?.user_id === 1734 || login?.user_id === 2;


    return (
        <div className="manager-menu">
            {showSettingsModal && (
                <>
                    <div className="popup" onClick={() => setShowSettingsModal(false)} />
                    <Settings close={() => setShowSettingsModal(false)} />
                </>
            )}

            {/* Profile Section */}
            <div className="left-item left-item-hidden">
                <MyImgRound image={employee?.image} />
                <div className="left-item-name">
                    <span>
                        <NavLink to="/main_employee/mypage">
                            {employee?.user?.first_name} {employee?.user?.last_name}
                        </NavLink>
                    </span>
                    <Timer />
                    <div className="menu-line-active" />
                </div>
            </div>

            {/* Menu Items */}
            {filteredMenuList.map((item, index) => {
                if (item.id !== 13 || login?.user?.canView || profession === "agent") {
                    if ((item.id === 14 || item.id === 15) && !isAdmin) {
                        return null;
                    }
                    return (
                        <NavLink key={index} to={item.url} className={({ isActive }) => (isActive ? "active" : "")}>
                            <div className="left-item" >
                                <span>{item.title}</span>
                                {window.location.href.includes(item.url) && <div className="menu-line" />}
                            </div>
                        </NavLink>
                    );
                }
            })}

            {/* Settings & Logout */}
            <div className="left-item left-item-hidden">
                <div onClick={() => setShowSettingsModal(true)}>էջի կարգավորումներ</div>
            </div>
            <div className="left-item left-item-hidden">
                <div
                    onClick={() => {
                        localStorage.clear();
                        navigate("/employee");
                    }}
                >
                    <span>Դուրս գալ</span>
                </div>
            </div>
        </div>
    );
};

export default ManagerMenu;
